import _ from "lodash";
import moment from "moment";
const uuidv4 = require("uuid/v1");
var md5 = require("md5");
const blobToBase64 = require("blob-to-base64");

export * from './tasks';
export * from './users';

export const SET_SIDEBAR_VISIBILITY = "SET_SIDEBAR_VISIBILITY";
export const SELECT_FORM = "SELECT_FORM";
export const REQUEST_FORMS = "REQUEST_FORMS";
export const RECEIVE_FORMS = "RECEIVE_FORMS";
export const UPDATE_FORMS = "UPDATE_FORMS";
export const SET_AUTH_SESSION = "SET_AUTH_SESSION";
export const SET_LOADING = "SET_LOADING";
export const SET_NOTIFICATION_LOADING = "SET_NOTIFICATION_LOADING";
export const SET_FILTER_UNREAD = "SET_FILTER_UNREAD";
export const RECEIVE_SENT_ITEMS = "RECEIVE_SENT_ITEMS";
export const OPENING_SENT_ITEM = "OPENING_SENT_ITEM";
export const RECEIVE_NOTIFICATIONS = "RECEIVE_NOTIFICATIONS";
export const SET_POSTING_STATUS = "SET_POSTING_STATUS";
export const UPDATE_FORM_EXISTS = "UPDATE_FORM_EXISTS";
export const SET_DEVICE_TOKEN = "SET_DEVICE_TOKEN";
export const RESET_SENT_ITEMS = "RESET_SENT_ITEMS";
export const SET_READY = "SET_READY";
export const SET_CONTROL_LOADING = "SET_CONTROL_LOADING";
export const UPDATE_FORM_VERSION = "UPDATE_FORM_VERSION";
export const SET_AUTH = "SET_AUTH";
export const CLEAR_SECTION_MANDATORY = "CLEAR_SECTION_MANDATORY";
export const SET_MANDATORY = "SET_MANDATORY";
export const SET_RESETPASSWORD = "SET_RESETPASSWORD";
export const RESET_PASSWORD_CHANGED = "RESET_PASSWORD_CHANGED";
export const ADD_REPEATING_FORM = "ADD_REPEATING_FORM";
export const UPDATE_PREVIEW = "UPDATE_PREVIEW";
export const UPDATE_REPORT = "UPDATE_REPORT";
export const DELETE_DRAFT = "DELETE_DRAFT";
export const DELETE_ALL_DRAFTS = "DELETE_ALL_DRAFTS";
export const SET_SUBMITTING = "SET_SUBMITTING";
export const CANCEL_REPEATING_FORM = "CANCEL_REPEATING_FORM";
export const DELETE_REPEATING_FORM = "DELETE_REPEATING_FORM";
export const UPDATE_SHOW_MSG = "UPDATE_SHOW_MSG";
export const RECEIVE_APPROVER_ARRAY = "RECEIVE_APPROVER_ARRAY";
export const UPDATE_SHOW_MSG_REPEAT = "UPDATE_SHOW_MSG_REPEAT";
export const SET_REPEATING_FORM = "SET_REPEATING_FORM";
export const RECEIVE_DRAFT_DATA = "RECEIVE_DRAFT_DATA";
export const SET_WORKING_DRAFT = "SET_WORKING_DRAFT";
export const RECEIVE_FORM_CONTROLS = "RECEIVE_FORM_CONTROLS";
export const CLEAN_IMAGES = "CLEAN_IMAGES";
export const CLONE_IMAGES = "CLONE_IMAGES";
export const RESET_COPY = "RESET_COPY";
export const ADD_FORM_ELEMENT = "ADD_FORM_ELEMENT";
export const SET_USERNAME = "SET_USERNAME";
export const SET_DRAFT_SAVED = "SET_DRAFT_SAVED";
export const SET_PASSWORD = "SET_PASSWORD";
export const UPDATE_FORM_ELEMENT = "UPDATE_FORM_ELEMENT";
export const UPDATE_IMAGE_FORM_ELEMENT = "UPDATE_IMAGE_FORM_ELEMENT";
export const UPDATE_FORM_TITLE = "UPDATE_FORM_TITLE";
export const SET_DATASOURCE = "SET_DATASOURCE";
export const UPDATE_DATASOURCE = "UPDATE_DATASOURCE";
export const SET_LOOKUP_DATA = "SET_LOOKUP_DATA";
export const RESET_FORM = "RESET_FORM";
export const RESET_FORMS = "RESET_FORMS";
export const RESET_NOTIFICATIONS = "RESET_NOTIFICATIONS";
export const RESET_IMAGES = "RESET_IMAGES";
export const RESET_RECOVERED_FORM = "RESET_RECOVERED_FORM";
export const RESET_FORM_ARRAY = "RESET_FORM_ARRAY";
export const UPDATE_LOOKUP = "UPDATE_LOOKUP";
export const ALERT_NOTIFICATIONS = "ALERT_NOTIFICATIONS";
export const READ_NOTIFICATION = "READ_NOTIFICATION";
export const UPDATE_FORM_ELEMENT_IMAGE = "UPDATE_FORM_ELEMENT_IMAGE";
export const SORT_FORMS = "SORT_FORMS";
export const SAVED_FORM = "SAVED_FORM";
export const UPDATE_FORM_ERRORS = "UPDATE_FORM_ERRORS";
export const FORM_VALIDATE = "FORM_VALIDATE";
export const UPDATE_FORM_VALIDATE = "UPDATE_FORM_VALIDATE";
export const REPEATING_FORM_VALIDATE = "REPEATING_FORM_VALIDATE";
export const UPDATE_REPEATING_FORM_VALIDATE = "UPDATE_REPEATING_FORM_VALIDATE";
export const LOGOUT = "LOGOUT";
export const CONNECT_FAIL = "CONNECT_FAIL";
export const SET_STORE = "SET_STORE";
export const LOGIN = "LOGIN";
export const SET_LOGO = "SET_LOGO";
export const SET_DEVICE = "SET_DEVICE";
export const SET_API = "SET_API";
export const RECEIVE_FORM_ARRAY = "RECEIVE_FORM_ARRAY";
export const CHANGE_CONNECTION_STATUS = "CHANGE_CONNECTION_STATUS";
export const SET_RECOVER_FORM = "SET_RECOVER_FORM";
export const ADD_TO_QUEUE = "ADD_TO_QUEUE";
export const ADD_TO_IMAGE_QUEUE = "ADD_TO_IMAGE_QUEUE";
export const REMOVE_FROM_ACTION_QUEUE = "REMOVE_FROM_ACTION_QUEUE";
export const REMOVE_FROM_IMAGE_QUEUE = "REMOVE_FROM_IMAGE_QUEUE";

export function setSidebarVisibility(visibility) {
  return {
    type: SET_SIDEBAR_VISIBILITY,
    visibility
  };
}

export function setAuthSession(sessionid) {
  return {
    type: SET_AUTH_SESSION,
    sessionid
  };
}

export function abortFetching() {
  return dispatch => {
    dispatch(setSubmitting(false));
  };
}

export function clearSectionMandatory(section) {
  return {
    type: CLEAR_SECTION_MANDATORY,
    section
  };
}

export function setMandatory(section, elementId) {
  return {
    type: SET_MANDATORY,
    section,
    element_id: elementId
  };
}

export function addRepeatingForm(repeatingFormUUID, controls) {
  return (dispatch, getState) => {
    const { form } = getState();

    dispatch(validateRepeatingForm(controls));
    dispatch(updateShowMsgRepeat(true));
    dispatch(updateRepeatingFormValidate(true));
    if (repeatingFormValid(getState())) {
      let expr = "";
      let i = 0;

      let itemVal = "";
      let calc = "";

      let item = [];
      item = _.filter(form.data, function(dsx) {
        return dsx.element_type === "19";
      });

      let c = [];
      item = _.filter(item, function(dsx) {
        controls.forEach(element => {
          if (
            Object.values(dsx.element_params).indexOf(element.toString()) !== -1
          ) {
            c.push(element);
          }
        });

        return c;
      });

      let cc = false;

      item = _.filter(item, function(dsx) {
        cc = false;
        c.forEach(element => {
          if (Object.values(dsx.element_params).indexOf(element) !== -1) {
            cc = true;
          }
        });
        return cc;
      });

      item.forEach(element => {
        let totalId = element.element_id;
        let countElement = element.element_params.A;
        expr = "";
        itemVal = "";
        i = 0;

        item = _.filter(form.draft, function(dsx) {
          return (
            Number(dsx.element_id) === Number(countElement) &&
            dsx.repeatingFormUUID !== repeatingFormUUID
          );
        });

        let itemCurrent = [];

        itemCurrent = _.filter(form.draft, function(dsx) {
          return (
            Number(dsx.element_id) === Number(countElement) &&
            dsx.repeatingFormUUID === repeatingFormUUID
          );
        });

        if (itemCurrent.length > 1) {
          itemCurrent = _.filter(form.draft, function(dsx) {
            return (
              Number(dsx.element_id) === Number(countElement) &&
              dsx.repeatingFormUUID === repeatingFormUUID &&
              dsx.repeatingFormEdit === true
            );
          });
        }

        item = item.concat(itemCurrent);

        if (itemCurrent.length > 0) {
          calc = itemCurrent[0].element_value;
        }
        item.forEach(element => {
          itemVal = Number(element.element_value);
          if (element.repeatingFormUUID === form.repeatingFormUUID) {
            if (calc !== "") {
              if (i === 0) {
                expr = calc;
              } else {
                expr += " + " + calc;
              }
            }
          } else {
            if (i === 0) {
              expr = itemVal;
            } else {
              expr += " + " + itemVal;
            }
          }

          i += 1;
        });

        calc = "";
        if (expr !== "") {
          calc = eval(expr);
        }

        if (calc.toString().indexOf(".") !== -1) {
          calc = calc.toFixed(3);
        } else {
          if (calc !== "") {
            calc = calc.toFixed(2);
          }
        }
        if (Number(calc) === 0) {
          calc = "";
        }
        dispatch(updateFormElement(-1, -1, -1, totalId, calc, true));
      });

      return dispatch(addRepeatingFormDo(repeatingFormUUID));
    } else {
    }
  };
}

export function addRepeatingFormDo(repeatingFormUUID) {
  return {
    type: ADD_REPEATING_FORM,
    repeatingFormUUID
  };
}

export function setAuth(authenticated, errorMessage) {
  return {
    type: SET_AUTH,
    authenticated,
    errorMessage
  };
}

export function reset() {
  return dispatch => {
    dispatch(resetForms());
    dispatch(resetForm());
  };
}

export function logout() {
  return {
    type: LOGOUT
  };
}

export function connectFail() {
  return {
    type: CONNECT_FAIL
  };
}

export function sortForms(value) {
  return {
    type: SORT_FORMS,
    value
  };
}

export function addFormElement(element_id, element_value) {
  return {
    type: ADD_FORM_ELEMENT,
    element_id: Number(element_id),
    element_value
  };
}

function replaceAll(str, find, replace) {
  return str.replace(new RegExp(find, "g"), replace);
}

export function updateForm(
  repeatingFormId,
  repeatingFormUUID,
  repeatingFormIndex,
  element_id,
  element_value,
  controls,
  barcode
) {
  return (dispatch, getState) => {
    const { form } = getState();
    dispatch(
      updateFormElement(
        repeatingFormId,
        repeatingFormUUID,
        repeatingFormIndex,
        element_id,
        element_value
      )
    );

    //CheckCalculate
    let item = [];
    item = _.filter(form.data, function(dsx) {
      return dsx.element_type === "18";
    });

    let ff = [];

    item.forEach(element => {
      ff.push(element.element_id);
    });

    let x = 0;
    let z = 0;
    let found = false;

    item = _.filter(item, function(dsx) {
      return (
        Object.values(dsx.element_params).indexOf(element_id.toString()) !==
          -1 ||
        dsx.element_params.E2s !== "" ||
        Object.values(ff).indexOf(dsx.element_params.E1.toString()) !== -1 ||
        Object.values(ff).indexOf(dsx.element_params.E2.toString()) !== -1
      );
    });

    let newvalues = [];

    for (let index = 0; index < item.length; index++) {
      let action = item[index].element_params.A;
      let expr = "";
      let i = 0;

      let itemVal = "";
      let formControl = item[index];

      for (var key in formControl.element_params) {
        if (key !== "A") {
          let repeatingFormUUID = form.repeatingFormUUID;

          if (key === "E2s" && formControl.element_params[key] !== "") {
            if (i === 0) {
              expr = formControl.element_params[key];
            } else {
              expr += " " + action + " " + formControl.element_params[key];
            }

            i += 1;
          } else {
            let item2 = _.filter(form.draft, function(dsx) {
              return (
                Number(dsx.element_id) ===
                  Number(formControl.element_params[key]) &&
                (dsx.repeatingFormUUID === undefined
                  ? -1
                  : dsx.repeatingFormUUID) === repeatingFormUUID
              );
            });

            if (item2.length === 2) {
              item2 = _.filter(item2, function(dsx) {
                return dsx.repeatingFormEdit === true;
              });
            }

            if (
              Number(formControl.element_params[key]) === Number(element_id)
            ) {
              if (i === 0) {
                expr = element_value;
              } else {
                expr += " " + action + " " + element_value;
              }

              i += 1;
            } else {
              if (item2.length > 0) {
                var itemx = _.filter(newvalues, function(dsx) {
                  return dsx.element_id === item2[0].element_id;
                });
                let nVal = "";
                if (itemx.length > 0) {
                  nVal = itemx[0].element_value;
                } else {
                  nVal = item2[0].element_value;
                }
                if (itemx.length > 0) {
                  nVal = itemx[0].element_value;
                } else {
                  nVal = item2[0].element_value;
                }
                if (nVal !== "") {
                  if (nVal.indexOf(":") === -1) {
                    itemVal = Number(nVal);
                  } else {
                    itemVal = nVal;
                  }
                  if (i === 0) {
                    expr = itemVal;
                  } else {
                    expr += " " + action + " " + itemVal;
                  }

                  i += 1;
                }
              }
            }
          }
        }
      }

      let calc = "";
      if (expr !== undefined) {
        if (
          typeof expr === 'string' &&
          expr !== "" &&
          expr.indexOf(" ") !== 0 &&
          expr.indexOf(" ") !== -1
        ) {
          if (expr.indexOf(":") !== -1) {
            let dt0 = expr.replace("SUB", "-");
            let dt = dt0.split("-");
            if (dt.length === 1 || dt0.indexOf("-") === -1) {
              calc = "";
            } else {
              let d1 = [];
              let d1A = [];
              if (dt[0].trim().length > 5) {
                d1 = replaceAll(dt[0].trim(), " ", "-").split("-");
                d1A = replaceAll(d1[0], "/", "-").split("-");
              } else {
                d1 = ["", dt[0].trim()];
                d1A = ["01", "01", "1900"];
              }
              let d2 = [];
              let d2A = [];
              if (dt[1].trim().length > 5) {
                d2 = replaceAll(dt[1].trim(), " ", "-").split("-");
                d2A = replaceAll(d2[0], "/", "-").split("-");
              } else {
                d2 = ["", dt[1].trim()];
                d2A = ["01", "01", "1900"];
              }
              calc =
                Math.abs(
                  new Date(
                    d1A[2] + "-" + d1A[1] + "-" + d1A[0] + "T" + d1[1] + ":00Z"
                  ) -
                    new Date(
                      d2A[2] +
                        "-" +
                        d2A[1] +
                        "-" +
                        d2A[0] +
                        "T" +
                        d2[1] +
                        ":00Z"
                    )
                ) / 36e5;
            }
          } else {
            calc = eval(
              expr
                .toString()
                .replace("MUL", "*")
                .replace("SUM", "+")
                .replace("SUB", "-")
                .replace("DIV", "/")
            );
          }
        }
      }
      if (calc.toString().indexOf(".") !== -1) {
        calc = calc.toFixed(3);
      } else {
        if (calc !== "") {
          calc = calc.toFixed(2);
        }
      }
      if (Number(calc) === 0) {
        calc = "";
      }

      newvalues.push({
        element_id: Number(formControl.element_id),
        element_value: calc
      });
      dispatch(
        updateFormElement(
          repeatingFormId,
          repeatingFormUUID,
          repeatingFormIndex,
          formControl.element_id,
          calc,
          true
        )
      );

      //CheckTotal
      if (repeatingFormId === -1) {
        let item3 = _.filter(form.data, function(dsx) {
          return dsx.element_type === "19";
        });

        item3 = _.filter(item3, function(dsx) {
          return (
            Object.values(dsx.element_params).indexOf(
              formControl.element_id.toString()
            ) !== -1
          );
        });

        if (item3.length > 0) {
          let totalId = item3[0].element_id;
          let countElement = item3[0].element_params.A;
          expr = "";
          itemVal = "";
          i = 0;

          item3 = _.filter(form.draft, function(dsx) {
            return Number(dsx.element_id) === Number(countElement);
          });

          item3.forEach(element => {
            itemVal = Number(element.element_value);
            if (element.repeatingFormUUID === form.repeatingFormUUID) {
              if (calc !== "") {
                if (i === 0) {
                  expr = calc;
                } else {
                  expr += " + " + calc;
                }
              }
            } else {
              if (i === 0) {
                expr = itemVal;
              } else {
                expr += " + " + itemVal;
              }
            }

            i += 1;
          });

          calc = "";
          if (expr !== "") {
            calc = eval(expr);
          }

          if (calc.toString().indexOf(".") !== -1) {
            calc = calc.toFixed(3);
          } else {
            if (calc !== "") {
              calc = calc.toFixed(2);
            }
          }
          if (Number(calc) === 0) {
            calc = "";
          }
          dispatch(updateFormElement(-1, -1, -1, totalId, calc, true));
        }
      }
    }

    if (barcode) {
      let timestamp = _.filter(form.data, function(dsx) {
        return dsx.element_type === "27" && dsx.element_params !== null;
      });

      timestamp = _.filter(timestamp, function(dsx) {
        return dsx.element_params.C === undefined
          ? ""
          : Number(dsx.element_params.C) === Number(element_id);
      });

      if (timestamp.length > 0) {
        setTimeout(() => {
          dispatch(
            updateFormElement(
              repeatingFormId,
              repeatingFormUUID,
              repeatingFormIndex,
              timestamp[0].element_id,
              element_value === "" ? "" : moment().format()
            )
          );
        }, 0);
      }
    }

    if (form.validate || form.repeatingFormValidate) {
      if (repeatingFormId !== -1) {
        if (form.repeatingFormValidate) {
          dispatch(validateRepeatingForm(controls));
        }
      } else {
        dispatch(validateForm(controls));
      }
    }
  };
}

function updateFormElement(
  repeatingFormId,
  repeatingFormUUID,
  repeatingFormIndex,
  element_id,
  element_value,
  secondary = false
) {
  return {
    type: UPDATE_FORM_ELEMENT,
    repeatingFormId,
    repeatingFormUUID,
    repeatingFormIndex,
    element_id: Number(element_id),
    element_value,
    secondary
  };
}

function setUsername(value) {
  return {
    type: SET_USERNAME,
    value
  };
}

function setPassword(value, changed) {
  return {
    type: SET_PASSWORD,
    value,
    changed
  };
}

export function resetPasswordChanged() {
  return {
    type: RESET_PASSWORD_CHANGED
  };
}

export function login() {
  return {
    type: LOGIN
  };
}

export function resetForm() {
  return {
    type: RESET_FORM
  };
}
export function resetImages(uuid, drafts, isDraft) {
  return {
    type: RESET_IMAGES,
    uuid,
    drafts,
    isDraft
  };
}

export function resetRecoveredForm() {
  return {
    type: RESET_RECOVERED_FORM
  };
}

export function resetFormArray() {
  return {
    type: RESET_FORM_ARRAY
  };
}

export function resetForms() {
  return {
    type: RESET_FORMS
  };
}

export function resetNotifications() {
  return {
    type: RESET_NOTIFICATIONS
  };
}

export function updateFormTitle(
  form_title,
  form_version,
  icon_path,
  form_id,
  form_uuid,
  approval_enabled
) {
  return {
    type: UPDATE_FORM_TITLE,
    form_title,
    form_version,
    icon_path,
    form_id,
    form_uuid,
    approval_enabled
  };
}

export function validateUser(username, password, deviceId) {
  return validateUserGo(null, username, password, false, deviceId);
}

function registerDevice(username, password) {
  var deviceId = uuidv4();

  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "account.addDevice",
    params: {
      terminal_serial: deviceId
    },
    id: uuidv4()
  });

  var headers = {
    "x-rpc-api-version": "5.1.2",
    "x-rpc-auth-device": deviceId,
    "x-rpc-auth-username": username,
    "x-rpc-auth-password": password,
    "content-type": "application/json",
    "cache-control": "no-cache"
  };

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    dispatch(setDevice(deviceId));
    return fetch(informedWebApp.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(json =>
        dispatch(validateUserGo(json.error, username, password, true, deviceId))
      );
  };
}

function validateUserGo(error, username, password, registerDevice, deviceId) {
  if (error === null) {
    var body = JSON.stringify({
      jsonrpc: "2.0",
      method: "account.validate",
      params: null,
      id: uuidv4()
    });

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": deviceId,
      "x-rpc-auth-username": username,
      "x-rpc-auth-password": password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };
    var sessionId = "";
    return (dispatch, getState) => {
      const { informedWebApp } = getState();

      dispatch(setUsername(username));
      dispatch(setPassword(password, false));
      dispatch(setLoading(true));
      return fetch(informedWebApp.api, {
        method: "POST",
        body: body,
        headers: headers,
        cache: "default",
        credentials: "include",
      })
        .then(function(response) {
          sessionId = response.headers.get("x-rpc-auth-session");
          //throw 'err!';
          dispatch(setAuthSession(sessionId));
          var json = response.json();
          return json;
        })
        .then(json =>
          dispatch(
            checkAuthentication(json, sessionId, username, password, deviceId)
          )
        )
        .then(complete => {
          dispatch(setLoading(false));
        })
        .catch(error => {
          dispatch(connectFail());
        });
    };
  } else {
    return dispatch => {
      dispatch(setAuthSession(""));
      dispatch(setAuth(false, error.data.fullMessage));
      dispatch(setLoading(false));
    };
  }
}

function getUserData(auth, sessionId, deviceId) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "account.getUserData",
    params: null,
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    return fetch(informedWebApp.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(json => dispatch(setCompany(json.result.data[0].store_id)))
      .then(() => dispatch(getCompany(sessionId, deviceId)))
      .then(() => dispatch(authDo(auth)));
  };
}

function getDatasources(ids = null) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "datasource.getList",
    params: null,
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp, forms } = getState();

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    return fetch(informedWebApp.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(json => {
        if (ids === null) {
          dispatch(setDatasource(json.result.data));
          return json.result.data;
        } else {
          let ds1 = _.filter(json.result.data, function(ds) {
            if (ids.indexOf(ds.datasource_id) !== -1) {
              let ds2 = _.filter(forms.datasource, function(dsx) {
                return (
                  dsx.datasource_id === ds.datasource_id &&
                  dsx.date_modified !== ds.date_modified
                );
              });

              let ds3 = _.filter(forms.datasource, function(dsx1) {
                return dsx1.datasource_id === ds.datasource_id;
              });

              if (ds2.length > 0 || ds3.length === 0) {
                dispatch(updateDatasource(ds2[0]));
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          });

          return ds1;
        }
      })
      .then(data => {
        var Promises = [];
        if (data !== null) {
          data.forEach(element => {
            if (element.direct === 0) {
              Promises.push(dispatch(getDatasouce(element.datasource_id)));
            }
          });

          Promise.all(Promises).then(() => {
            dispatch(setLoading(false));
          });
        } else {
          dispatch(setLoading(false));
        }
      });
  };
}

function getCompany(sessionId, deviceId) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "company.getPersonalizationData",
    params: null,
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    return fetch(informedWebApp.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(json => {
        let baseColor = json.result.data[0].config_app_main_color;

        dispatch(setColors(json.result.data[0].config_app_logo, baseColor));
      });
  };
}

function getDatasouce(datasourceId) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "datasource.getOne",
    params: {
      datasource_id: datasourceId
    },
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    return fetch(informedWebApp.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(data => {
        if (data.result !== null) {
          dispatch(setLookupData(datasourceId, data.result.data));
        }
      });
  };
}

export function setResetPassword(value) {
  return {
    type: SET_RESETPASSWORD,
    value
  };
}

export function resetPassword(email) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "account.resetPassword",
    params: {
      user_email: email
    },
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();
    dispatch(setResetPassword(3));

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device":
        informedWebApp.deviceId === "" ? uuidv4() : informedWebApp.deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    return fetch(informedWebApp.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(json => {
        if (json.error === null) {
          dispatch(setResetPassword(1));
        } else {
          dispatch(setResetPassword(2));
        }
      });
  };
}

export function changePassword(password) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "account.changePassword",
    params: {
      password: password
    },
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();
    dispatch(setLoading(true));

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    return fetch(informedWebApp.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(json => dispatch(confirmPassword(json, password)));
  };
}

function confirmPassword(json, password) {
  if (json.error === null) {
    return dispatch => {
      dispatch(setPassword(password, true));
      dispatch(setLoading(false));
    };
  }
}

export function getBase64(blob, repeatingFormUUID, element_id) {
  blobToBase64(blob, function(error, base64) {
    return { base64, repeatingFormUUID, element_id };
  });
}

export function getFile(fileName, repeatingFormUUID, element_id) {
  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var body = JSON.stringify({
      jsonrpc: "2.0",
      method: "form.getFile",
      params: {
        file_name: fileName,
        output: "base64"
      },
      id: uuidv4()
    });

    var headers = {
      "x-rpc-api-version": "4.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };
    if (informedWebApp.isConnected) {
      return fetch(informedWebApp.api, {
        method: "POST",
        body: body,
        headers: headers,
        cache: "default",
        credentials: "same-origin"
      })
        .then(function(response) {
          var json = response.json();
          return json;
        })
        .then(json => {
          return {
            content: json.result.data[0].content,
            type: json.result.data[0].type,
            repeatingFormUUID,
            element_id
          };
        })
        .catch(function(e) {});
    }
  };
}

export function getFormReport(
  result_id,
  form_title,
  form_version,
  date_added,
  form_id,
  icon_path
) {
  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var body = JSON.stringify({
      jsonrpc: "2.0",
      method: "form.generateReport",
      params: {
        result_id: result_id,
        output: "stream"
      },
      id: uuidv4()
    });

    var headers = {
      "x-rpc-api-version": "4.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      //"content-type": "application/x-download",
      "content-type": "application/json",
      "cache-control": "no-cache"
    };
    dispatch(setSubmitting(true));
    if (informedWebApp.isConnected) {
      return fetch(informedWebApp.api, {
        method: "POST",
        body: body,
        headers: headers,
        responseType: "blob",
        cache: "default",
        credentials: "same-origin"
      })
        .then(function(response) {
          var blob = response.blob();
          return blob;
        })
        .then(blob => {
          var objectURL = URL.createObjectURL(blob);

          dispatch(
            updateReport(
              objectURL,
              form_title,
              form_version,
              result_id,
              date_added,
              form_id,
              icon_path
            )
          );

          setTimeout(() => {
            dispatch(setSubmitting(false));
          }, 1000);
        })
        .catch(function(e) {
          dispatch(setSubmitting(false));
        });
    }
  };
}

export function submitFormPreview(form_id, draft) {
  let hash = "";
  let i = 0;

  draft.forEach(element => {
    i += 1;
    if (i === 1) {
      hash += element.element_id + "=" + element.element_value;
    } else {
      hash += ";" + element.element_id + "=" + element.element_value;
    }
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var body = JSON.stringify({
      jsonrpc: "2.0",
      method: "form.preview",
      params: {
        form_hash: md5(hash),
        form_id: form_id,
        elements: draft,
        application_version: informedWebApp.application_version,
        terminal_os: informedWebApp.terminal_os
      },
      id: uuidv4()
    });

    var headers = {
      "x-rpc-api-version": "4.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    if (informedWebApp.isConnected) {
      return fetch(informedWebApp.api, {
        method: "POST",
        body: body,
        headers: headers,
        responseType: "blob",
        cache: "default",
        credentials: "same-origin"
      })
        .then(function(response) {
          var blob = response.blob();
          return blob;
        })
        .then(blob => {
          const { form } = getState();

          var objectURL = URL.createObjectURL(blob);
          if (form.submitting) {
            dispatch(updatePreview_go(objectURL));

            setTimeout(() => {
              dispatch(setSubmitting(false));
            }, 1000);
          }
        })
        .catch(function(e) {
          dispatch(setSubmitting(false));
        });
    }
  };
}

export function updateReport(
  report,
  form_title,
  form_version,
  result_id,
  date_added,
  form_id,
  icon_path
) {
  return {
    type: UPDATE_REPORT,
    report,
    form_title,
    form_version,
    result_id,
    date_added,
    form_id,
    icon_path
  };
}

export function updatePreview_go(preview) {
  return {
    type: UPDATE_PREVIEW,
    preview
  };
}

export function setDevice(deviceId) {
  return {
    type: SET_DEVICE,
    deviceId
  };
}

export function setApi(isTest) {
  return {
    type: SET_API,
    value: isTest ?
      {
        api: "https://test.in-formed.co.uk/api.php",
        apiv2: 'https://test.in-formed.co.uk/api/v2'
      } : {
        api: "https://www.in-formed.co.uk/api.php",
        apiv2: 'https://www.in-formed.co.uk/api/v2'
      }
  }
}

export function setColors(store_logo, store_color) {
  return {
    type: SET_LOGO,
    store_logo,
    store_color
  };
}

export function setDatasource(datasource) {
  return {
    type: SET_DATASOURCE,
    datasource
  };
}
export function updateDatasource(datasource) {
  return {
    type: UPDATE_DATASOURCE,
    datasource
  };
}
function setLookupData(datasourceId, lookupData) {
  return {
    type: SET_LOOKUP_DATA,
    datasourceId,
    lookupData
  };
}

export function setCompany(store_id) {
  return {
    type: SET_STORE,
    store_id: store_id
  };
}

function getVersion(vv) {
  return Number(vv.substring(0, vv.indexOf(".")));
}

export function submitFormDoQ(
  draftName,
  sessionId,
  form_id,
  form_version,
  draftX,
  deviceId,
  uuid,
  isDraft,
  result_id,
  latitude,
  longitude,
  notification_id
) {
  let hash = "";
  let i = 0;

  let draft = draftX;

  draft = draft.map(function(element) {
    if (element.base64 !== undefined) {
      delete element["base64"];
      return element;
    } else {
      return element;
    }
  });

  draft.forEach(element => {
    i += 1;
    if (i === 1) {
      hash += element.element_id + "=" + element.element_value;
    } else {
      hash += ";" + element.element_id + "=" + element.element_value;
    }
  });

  if (i === 0) {
    return dispatch => {
      dispatch(removeFromQueue(uuid));
    };
  } else {
    var body = "";

    return (dispatch, getState) => {
      const { informedWebApp } = getState();

      let vv = getVersion(informedWebApp.application_version);

      if (informedWebApp.api.indexOf("test") !== -1 || vv > 2) {
        if (result_id === "" || result_id === undefined || result_id === "undefined" || !isDraft) {
          if (isDraft) {
            body = JSON.stringify({
              jsonrpc: "2.0",
              method: "draft.postDraft",
              params: {
                form_id: form_id,
                form_version: form_version,
                title: draftName,
                elements: draft
              },
              id: uuidv4()
            });
          } else {
            body = JSON.stringify({
              jsonrpc: "2.0",
              method: "form.postForm",
              params: {
                form_hash: md5(hash),
                form_id: form_id,
                form_version: form_version,
                application_version: informedWebApp.application_version,
                terminal_os: informedWebApp.terminal_os,
                draft_id: result_id,
                elements: draft,
                "notification_id": notification_id === '0' ? '' : notification_id
              },
              id: uuidv4()
            });
          }
        } else {
          body = JSON.stringify({
            jsonrpc: "2.0",
            method: "draft.postDraft",
            params: {
              form_id: form_id,
              form_version: form_version,
              id: result_id,
              title: draftName,
              elements: draft
            },
            id: uuidv4()
          });
        }
      } else {
        if (result_id === "" || result_id === undefined) {
          body = JSON.stringify({
            jsonrpc: "2.0",
            method: "form.postForm",
            params: {
              form_hash: md5(hash),
              form_id: form_id,
              form_version: form_version,
              application_version: informedWebApp.application_version,
              terminal_os: informedWebApp.terminal_os,
              draft: isDraft ? "1" : "0",
              draft_name: draftName,
              elements: draft,
              "notification_id": notification_id === '0' ? '' : notification_id
            },
            id: uuidv4()
          });
        } else {
          body = JSON.stringify({
            jsonrpc: "2.0",
            method: "form.postForm",
            params: {
              form_hash: md5(hash),
              form_id: form_id,
              form_version: form_version,
              application_version: informedWebApp.application_version,
              terminal_os: informedWebApp.terminal_os,
              result_id: result_id,
              draft: isDraft ? "1" : "0",
              draft_name: draftName,
              elements: draft,
              "notification_id": notification_id === '0' ? '' : notification_id
            },
            id: uuidv4()
          });
        }
      }
      var headers = {
        "x-rpc-api-version": "5.1.2",
        "x-rpc-auth-device": deviceId,
        //"X-RPC-Auth-Session": informedWebApp.sessionId,
        "x-rpc-auth-username": informedWebApp.username,
        "x-rpc-auth-password": informedWebApp.password,
        //"x-rpc-device-latitude": latitude, // not allowed by cors preflight
        //"x-rpc-device-longitude": longitude,
        "content-type": "application/json",
        "cache-control": "no-cache"
      };

      if (informedWebApp.isConnected) {
        return fetch(informedWebApp.api, {
          method: "POST",
          body: body,
          headers: headers,
          cache: "default",
          credentials: "same-origin"
        })
          .then(function(response) {
            var json = response.json();
            return json;
          })
          .then(json => {
            if (1 === 1) {
              // no repeating forms
              if (!isDraft) {
                dispatch(removeFromQueue(uuid));
              } else {
                let vv = getVersion(informedWebApp.application_version);
                if (informedWebApp.api.indexOf("test") !== -1 || vv > 2) {
                  dispatch(
                    setDraftSaved(
                      uuid,
                      json.result.data[0].id,
                      json.result.data[0].id.date_added,
                      json.result.data[0].id.date_modified
                    )
                  );
                } else {
                  dispatch(setDraftSaved(uuid, json.result.data[0].result_id));
                }
              }
            } else {
              // yes repeating forms
              let result_id = json.result.data[0].result_id;

              let draftR = _.filter(draftX, function(draft) {
                return draft.repeatingFormId !== undefined;
              });
              let data = _(draftR)
                .map("repeatingFormUUID")
                .uniq()
                .value();
              var Promises = [];
              data.forEach(element => {
                let repeatingForm = _.filter(draftR, function(draft) {
                  return draft.repeatingFormUUID === element;
                });

                var repeatingFormX = repeatingForm.map(function(element) {
                  delete element["repeatingFormId"];
                  delete element["repeatingFormUUID"];
                  delete element["repeatingFormIndex"];
                  delete element["repeatingFormEdit"];
                  return element;
                });

                Promises.push(
                  dispatch(
                    submitSubForm(
                      form_id,
                      repeatingFormX,
                      deviceId,
                      uuid,
                      isDraft,
                      result_id
                    )
                  )
                );
              });

              Promise.all(Promises).then(() => {
                if (!isDraft) {
                  dispatch(removeFromQueue(uuid));
                } else {
                  dispatch(setDraftSaved(uuid));
                }
              });
            }
          })
          .catch(error => {
            alert(error.message);
          });
      } else {
      }
    };
  }
}

export function submitSubForm(
  form_id,
  draft,
  deviceId,
  uuid,
  isDraft,
  parent_result_id
) {
  let hash = "";
  let i = 0;

  draft.forEach(element => {
    i += 1;
    if (i === 1) {
      hash += element.element_id + "=" + element.element_value;
    } else {
      hash += ";" + element.element_id + "=" + element.element_value;
    }
  });

  var body = "";

  return (dispatch, getState) => {
    const { informedWebApp, form } = getState();

    body = JSON.stringify({
      jsonrpc: "2.0",
      method: "form.postForm",
      params: {
        form_hash: md5(hash),
        form_id: form_id,
        parent_result_id: parent_result_id,
        elements: draft
      },
      id: uuidv4()
    });

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    if (informedWebApp.isConnected) {
      return fetch(informedWebApp.api, {
        method: "POST",
        body: body,
        headers: headers,
        cache: "default",
        credentials: "same-origin"
      })
        .then(function(response) {
          var json = response.json();
          return json;
        })
        .then(json => {
          let c = json;
        });
    } else {
    }
  };
}

function syncForms(uuid, isDraft) {
  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    let test =
      informedWebApp.api === "https://www.in-formed.co.uk/api.php"
        ? false
        : true;

    var q = _.filter(informedWebApp.actionQueue, {
      storeId: informedWebApp.storeId,
      test: test
    });
    q.forEach(form => {
      if ((form.isDraft && !form.saved) || !form.isDraft) {
        dispatch(
          submitFormDoQ(
            form.draftName,
            informedWebApp.sessionId,
            form.form_id,
            form.form_version,
            form.draft,
            informedWebApp.deviceId,
            form.uuid,
            form.isDraft,
            form.result_id,
            form.latitude,
            form.longitude,
            form.notification_id
          )
        );
      }
    });
  };
}

function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || "";
  sliceSize = sliceSize || 512;

  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);

    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export function uploadSignatureQ(
  repeatingFormEdit,
  repeatingFormId,
  repeatingFormUUID,
  repeatingFormIndex,
  element_id,
  uri,
  deviceId,
  sessionId,
  uuid,
  fileType,
  isDraft
) {
  var crc = uuidv4();

  var jsonRequest = JSON.stringify({
    jsonrpc: "2.0",
    method: "form.fupload",
    params: {
      file_name: "signature32." + fileType,
      file_crc: md5(crc)
    },
    id: uuidv4()
  });

  var form = new FormData();
  form.append("request", jsonRequest);

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    if (uri === "") {
      dispatch(removeFromImageQueue(uuid, element_id, repeatingFormUUID));
    } else {
    }
  };
}

function processQ(uuid) {
  return (dispatch, getState) => {
    const { informedWebApp } = getState();
    let test =
      informedWebApp.api === "https://www.in-formed.co.uk/api.php"
        ? false
        : true;

    var q = _.filter(informedWebApp.actionQueue, {
      uuid: uuid,
      storeId: informedWebApp.storeId,
      test: test
    });
    var formCount = q.length;

    let isDraft = false;

    if (informedWebApp.isConnected && formCount > 0) {
      isDraft = q[0].isDraft;

      //sync forms
      dispatch(syncForms(uuid, isDraft));
    }
  };
}

export function uploadSignature(
  isDraft,
  repeatingFormId,
  repeatingFormUUID,
  repeatingFormIndex,
  element_id,
  uri,
  base64,
  deviceId,
  sessionId,
  uuid,
  controls
) {
  var crc = uuidv4();

  var jsonRequest = JSON.stringify({
    jsonrpc: "2.0",
    method: "form.fupload",
    params: {
      file_name: "signature32.png",
      file_crc: md5(crc)
    },
    id: uuidv4()
  });

  var formD = new FormData();
  formD.append("request", jsonRequest);

  return (dispatch, getState) => {
    const { informedWebApp, form } = getState();

    if (1 === 2) {
    } else {
      let timestamp = _.filter(form.data, function(dsx) {
        return dsx.element_type === "27" && dsx.element_params !== null;
      });

      timestamp = _.filter(timestamp, function(dsx) {
        return dsx.element_params.C === undefined
          ? ""
          : Number(dsx.element_params.C) === Number(element_id);
      });

      if (uri !== "") {
        dispatch(
          updateFormElement(
            repeatingFormId,
            repeatingFormUUID,
            repeatingFormIndex,
            element_id,
            uri
          )
        );

        if (timestamp.length > 0) {
          setTimeout(() => {
            dispatch(
              updateFormElement(
                repeatingFormId,
                repeatingFormUUID,
                repeatingFormIndex,
                timestamp[0].element_id,
                moment().format()
              )
            );
          }, 0);
        }

        dispatch(
          addToImageQueue(
            isDraft,
            form.repeatingFormEdit,
            repeatingFormId,
            repeatingFormUUID,
            repeatingFormIndex,
            uuid,
            element_id,
            informedWebApp.storeId,
            uri,
            "png"
          )
        );
        if (form.validate || form.repeatingFormValidate) {
          if (repeatingFormId !== -1) {
            if (form.repeatingFormValidate) {
              dispatch(validateRepeatingForm(controls));
            }
          } else {
            dispatch(validateForm(controls));
          }
        }
      } else {
        dispatch(
          updateFormElement(
            repeatingFormId,
            repeatingFormUUID,
            repeatingFormIndex,
            element_id,
            ""
          )
        );

        if (timestamp.length > 0) {
          setTimeout(() => {
            dispatch(
              updateFormElement(
                repeatingFormId,
                repeatingFormUUID,
                repeatingFormIndex,
                timestamp[0].element_id,
                ""
              )
            );
          }, 0);
        }

        dispatch(
          addToImageQueue(
            isDraft,
            form.repeatingFormEdit,
            repeatingFormId,
            repeatingFormUUID,
            repeatingFormIndex,
            uuid,
            element_id,
            informedWebApp.storeId,
            uri,
            "png"
          )
        );
      }

      if (form.validate || form.repeatingFormValidate) {
        if (repeatingFormId !== -1) {
          if (form.repeatingFormValidate) {
            dispatch(validateRepeatingForm(controls));
          }
        } else {
          dispatch(validateForm(controls));
        }
      }
    }
  };
}

export function submitFormDo(
  copy,
  draftName,
  sessionId,
  form_id,
  draftX,
  deviceId,
  uuid,
  isDraft,
  result_id,
  latitude,
  longitude,
  drafts,
  approval_enabled,
  notification_id
) {
  let hash = "";
  let i = 0;
  let draft = _.filter(draftX, function(draft) {
    return draft.repeatingFormId === undefined;
  });

  draft.forEach(element => {
    i += 1;
    if (i === 1) {
      hash += element.element_id + "=" + element.element_value;
    } else {
      hash += ";" + element.element_id + "=" + element.element_value;
    }
  });

  return (dispatch, getState) => {
    const { informedWebApp, form, sentItems } = getState();

    dispatch(setSubmitting_do(false));
    let icon = form.icon_path;
    if (copy) {
      icon = sentItems.report_icon_path;
      dispatch(resetSentItems());
    }

    dispatch(
      addToQueue(
        draftName,
        result_id,
        form_id,
        draftX,
        informedWebApp.storeId,
        uuid,
        isDraft,
        false,
        form.title,
        form.version,
        icon,
        latitude,
        longitude,
        notification_id
      )
    );
    dispatch(savedForm(null));

    setTimeout(() => {
      if (!drafts) {
        dispatch(processQ(uuid));
      } else {
        dispatch(cleanImages(uuid));

        dispatch(processQ(uuid));
      }
    }, 0);
  };
}

export function uploadImage(
  isDraft,
  repeatingFormId,
  repeatingFormUUID,
  repeatingFormIndex,
  element_id,
  uri,
  base64,
  deviceId,
  sessionId,
  uuid,
  galleryImage,
  controls
) {
  var crc = uuidv4();

  var jsonRequest = JSON.stringify({
    jsonrpc: "2.0",
    method: "form.fupload",
    params: {
      file_name: "signature32.JPEG",
      file_crc: md5(crc)
    },
    id: uuidv4()
  });

  var formData = new FormData();
  formData.append("request", jsonRequest);

  var filename = uri;
  return (dispatch, getState) => {
    const { informedWebApp, form } = getState();

    if (uri.indexOf(".JPEG") === -1) {
      var ImageURL = uri;
      // Split the base64 string in data and contentType
      var block = ImageURL.split(";");
      // Get the content type of the image
      var contentType = block[0].split(":")[1];
      // get the real base64 content of the file
      var realData = block[1].split(",")[1];

      // Convert it to a blob to upload
      var blob = b64toBlob(realData, contentType);

      formData.append("files", blob, "signature32.JPEG");
    }

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      //"content-type": "multipart/form-data",
      "cache-control": "no-cache"
    };

    if (1 === 2) {
      if (uri.indexOf(".JPEG") !== -1) {
        dispatch(
          updateFormElement(
            repeatingFormId,
            repeatingFormUUID,
            repeatingFormIndex,
            element_id,
            ""
          )
        );
        if (form.validate || form.repeatingFormValidate) {
          if (repeatingFormId !== -1) {
            if (form.repeatingFormValidate) {
              dispatch(validateRepeatingForm(controls));
            }
          } else {
            dispatch(validateForm(controls));
          }
        }
      } else {
        dispatch(
          updateFormElement(
            repeatingFormId,
            repeatingFormUUID,
            repeatingFormIndex,
            element_id,
            "[busy]"
          )
        );

        return fetch(informedWebApp.api, {
          method: "POST",
          body: formData,
          headers: headers,
          cache: "default",
          credentials: "same-origin"
        })
          .then(function(response) {
            var json = response.json();
            return json;
          })
          .then(json => {
            let filename = json.result.data[0].file_name;

            dispatch(
              updateFormElement(
                repeatingFormId,
                repeatingFormUUID,
                repeatingFormIndex,
                element_id,
                filename
              )
            );

            let timestamp = _.filter(form.data, function(dsx) {
              return dsx.element_type === "27" && dsx.element_params !== null;
            });

            timestamp = _.filter(timestamp, function(dsx) {
              return dsx.element_params.C === undefined
                ? ""
                : Number(dsx.element_params.C) === Number(element_id);
            });

            if (timestamp.length > 0) {
              setTimeout(() => {
                dispatch(
                  updateFormElement(
                    repeatingFormId,
                    repeatingFormUUID,
                    repeatingFormIndex,
                    timestamp[0].element_id,
                    moment().format()
                  )
                );
              }, 0);
            }
          })
          .then(complete => {
            if (form.validate || form.repeatingFormValidate) {
              if (repeatingFormId !== -1) {
                if (form.repeatingFormValidate) {
                  dispatch(validateRepeatingForm(controls));
                }
              } else {
                dispatch(validateForm(controls));
              }
            }
          });
      }
    } else {
      let timestamp = _.filter(form.data, function(dsx) {
        return dsx.element_type === "27" && dsx.element_params !== null;
      });

      timestamp = _.filter(timestamp, function(dsx) {
        return dsx.element_params.C === undefined
          ? ""
          : Number(dsx.element_params.C) === Number(element_id);
      });

      if (uri !== "") {
        dispatch(
          updateFormElement(
            repeatingFormId,
            repeatingFormUUID,
            repeatingFormIndex,
            element_id,
            uri
          )
        );

        if (timestamp.length > 0) {
          setTimeout(() => {
            dispatch(
              updateFormElement(
                repeatingFormId,
                repeatingFormUUID,
                repeatingFormIndex,
                timestamp[0].element_id,
                moment().format()
              )
            );
          }, 0);
        }

        dispatch(
          addToImageQueue(
            isDraft,
            form.repeatingFormEdit,
            repeatingFormId,
            repeatingFormUUID,
            repeatingFormIndex,
            uuid,
            element_id,
            informedWebApp.storeId,
            filename,
            "JPEG"
          )
        );
      } else {
        dispatch(
          updateFormElement(
            repeatingFormId,
            repeatingFormUUID,
            repeatingFormIndex,
            element_id,
            ""
          )
        );

        if (timestamp.length > 0) {
          setTimeout(() => {
            dispatch(
              updateFormElement(
                repeatingFormId,
                repeatingFormUUID,
                repeatingFormIndex,
                timestamp[0].element_id,
                ""
              )
            );
          }, 0);
        }
        dispatch(
          addToImageQueue(
            isDraft,
            form.repeatingFormEdit,
            repeatingFormId,
            repeatingFormUUID,
            repeatingFormIndex,
            uuid,
            element_id,
            informedWebApp.storeId,
            uri,
            "JPEG"
          )
        );
      }
    }
  };
}

export function getFormControls(formControls, form_id, formVersion) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "form.readForms",
    params: null,
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    dispatch(setLoading(true));
    if (informedWebApp.isConnected) {
      return fetch(informedWebApp.api, {
        method: "POST",
        body: body,
        headers: headers,
        cache: "default",
        credentials: "same-origin"
      })
        .then(function(response) {
          var json = response.json();
          return json;
        })
        .then(json => {
          let latest = _.filter(json.result.data, function(forms) {
            return Number(forms.form_id) === Number(form_id);
          });
          if (latest.length === 0) {
            dispatch(updateFormExists(false));
            return false;
          } else {
            if (
              Number(latest[0].form_version) === Number(formVersion) &&
              formControls !== null
            ) {
              dispatch(updateFormVersion(formVersion));
              dispatch(receiveFormControls(formControls));
              return false;
            } else {
              dispatch(updateForms(latest[0]));
              dispatch(updateFormVersion(latest[0].form_version));
              dispatch(
                readFormControls(
                  "",
                  form_id,
                  informedWebApp.deviceId,
                  latest[0].form_version,
                  true
                )
              );
              return true;
            }
          }
        })
        .then(refresh => {
          if (!refresh) {
            dispatch(setLoading(false));
          }
        });
    } else {
      setTimeout(() => {
        Promise.resolve("Success")
          .then(function(response) {
            return response;
          })
          .then(json => {
            dispatch(updateFormVersion(formVersion));
            dispatch(receiveFormControls(formControls));
          })
          .then(complete => dispatch(setLoading(false)));
      }, 0);
    }
  };
}

export function connectionState(status) {
  return {
    type: CHANGE_CONNECTION_STATUS,
    isConnected: status
  };
}

export function recoverForm(draft, formId, uuid, isDraft) {
  return {
    type: SET_RECOVER_FORM,
    draft,
    formId,
    uuid,
    isDraft
  };
}

export function setWorkingDraft(draft, uuid) {
  return {
    type: SET_WORKING_DRAFT,
    draft,
    uuid
  };
}

export function cleanImages(uuid) {
  return {
    type: CLEAN_IMAGES,
    uuid
  };
}

export function cloneImages(uuid) {
  return {
    type: CLONE_IMAGES,
    uuid
  };
}

export function resetCopy() {
  return {
    type: RESET_COPY
  };
}

export function readSentItemData(
  result_id,
  title,
  form_id,
  form_version,
  date_added
) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "result.getSentItemData",
    params: {
      result_id: result_id
    },
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp, forms } = getState();

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    dispatch(setLoading(true));

    let currentForm = _.filter(forms.data, function(data) {
      return Number(data.form_id) === Number(form_id);
    });

    let icon_path = "";
    if (currentForm.length > 0) {
      icon_path = currentForm[0].icon_path;
    }

    return fetch(informedWebApp.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(json => {
        var Promises = [];
        json.result.data.forEach(element => {
          if (
            element.element_value.toLowerCase().indexOf("jpeg") !== -1 ||
            element.element_value.toLowerCase().indexOf("png") !== -1
          ) {
            if (element.element_value.indexOf("base64") !== -1) {
            } else {
              Promises.push(
                dispatch(
                  getFile(
                    element.element_value,
                    element.repeatingFormUUID,
                    element.element_id
                  )
                )
              );
            }
          }
        });
        Promise.all(Promises)
          .then(s => {
            s.forEach(element => {
              if (element.repeatingFormUUID === -1) {
                let draft = _.filter(json.result.data, function(draft) {
                  if (draft.element_id === element.element_id) {
                    return true;
                  } else {
                    return false;
                  }
                });
                draft[0].element_value =
                  element.type === "image/jpeg"
                    ? "data:image/JPEG;base64," + element.content
                    : "data:image/PNG;base64," + element.content;
              } else {
                let draft = _.filter(json.result.data, function(draft) {
                  if (
                    draft.element_id === element.element_id &&
                    draft.repeatingFormUUID === element.repeatingFormUUID
                  ) {
                    return true;
                  } else {
                    return false;
                  }
                });
                draft[0].element_value =
                  element.type === "image/jpeg"
                    ? "data:image/JPEG;base64," + element.content
                    : "data:image/PNG;base64," + element.content;
              }
            });

            dispatch(
              receiveDraftData(
                json.result,
                result_id,
                "",
                form_id,
                form_version,
                icon_path,
                date_added,
                informedWebApp.storeId,
                uuidv4()
              )
            );
          })
          .then(() => dispatch(setLoading(false)));
      })
      .then(complete => {});
  };
}

export function readDraftData(
  result_id,
  title,
  form_id,
  form_version,
  date_added
) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "draft.getDraftData",
    params: {
      id: result_id
    },
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp, forms } = getState();

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    dispatch(setLoading(true));

    let currentForm = _.filter(forms.data, function(data) {
      return Number(data.form_id) === Number(form_id);
    });

    let icon_path = "";
    if (currentForm.length > 0) {
      icon_path = currentForm[0].icon_path;
    }

    return fetch(informedWebApp.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(json => {
        var Promises = [];
        json.result.data.forEach(element => {
          if (
            element.element_value.toLowerCase().indexOf("jpeg") !== -1 ||
            element.element_value.toLowerCase().indexOf("png") !== -1
          ) {
            if (element.element_value.indexOf("base64") !== -1) {
            } else {
              Promises.push(
                dispatch(
                  getFile(
                    element.element_value,
                    element.repeatingFormUUID,
                    element.element_id
                  )
                )
              );
            }
          }
        });
        Promise.all(Promises).then(s => {
          s.forEach(element => {
            if (element.repeatingFormUUID === -1) {
              let draft = _.filter(json.result.data, function(draft) {
                if (draft.element_id === element.element_id) {
                  return true;
                } else {
                  return false;
                }
              });
              draft[0].element_value =
                element.type === "image/jpeg"
                  ? "data:image/JPEG;base64," + element.content
                  : "data:image/PNG;base64," + element.content;
            } else {
              let draft = _.filter(json.result.data, function(draft) {
                if (
                  draft.element_id === element.element_id &&
                  draft.repeatingFormUUID === element.repeatingFormUUID
                ) {
                  return true;
                } else {
                  return false;
                }
              });
              draft[0].element_value =
                element.type === "image/jpeg"
                  ? "data:image/JPEG;base64," + element.content
                  : "data:image/PNG;base64," + element.content;
            }
          });

          dispatch(
            receiveDraftData(
              json.result,
              result_id,
              title,
              form_id,
              form_version,
              icon_path,
              date_added,
              informedWebApp.storeId,
              uuidv4()
            )
          );
        });
      })
      .then(complete => dispatch(setLoading(false)));
  };
}

export function readFormControls(
  sessionId,
  form_id,
  device,
  version,
  refresh = false
) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "form.readFormControls",
    params: {
      form_id: form_id,
      form_version: version.toString()
    },
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": device,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    dispatch(setLoading(true));
    return fetch(informedWebApp.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(json => {
        if (refresh) {
          dispatch(receiveFormControls(json.result.data));
          let draft = _.filter(json.result.data, function(draft) {
            if (draft.element_params !== null) {
              if (
                draft.element_params.Ds !== undefined &&
                draft.element_type === "16"
              ) {
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          });
          let v = draft;
          let cv = _(draft)
            .map("element_params.Ds")
            .uniq()
            .value();

          if (cv.length > 0) {
            dispatch(getDatasources(cv));
            return true;
          } else {
            return false;
          }
        } else {
          dispatch(receiveFormControlsX(json.result.data, form_id));
          return true;
        }
      })
      .then(cancel => {
        if (refresh && !cancel) {
          dispatch(setLoading(false));
        }
      });
  };
}

export function updateLookup(lookup) {
  return {
    type: UPDATE_LOOKUP,
    lookup
  };
}

export function alertNotifications(value) {
  return {
    type: ALERT_NOTIFICATIONS,
    value
  };
}

export function setReadNotification(id) {
  return {
    type: READ_NOTIFICATION,
    id
  };
}

export function receivedNotification(id) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "notification.trackDelivery",
    params: {
      id: id
    },
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var headers = {
      "x-rpc-api-version": "4.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    if (informedWebApp.isConnected) {
      return fetch(informedWebApp.api, {
        method: "POST",
        body: body,
        headers: headers,
        cache: "default",
        credentials: "same-origin"
      })
        .then(function(response) {
          var json = response.json();
          return json;
        })
        .then(json => {});
    }
  };
}

export function readNotification(id) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "notification.trackOpen",
    params: {
      id: id
    },
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var headers = {
      "x-rpc-api-version": "4.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    if (informedWebApp.isConnected) {
      return fetch(informedWebApp.api, {
        method: "POST",
        body: body,
        headers: headers,
        cache: "default",
        credentials: "same-origin"
      })
        .then(function(response) {
          var json = response.json();
          return json;
        })
        .then(json => {
          dispatch(setReadNotification(id));
        });
    }
  };
}

export function getNotifications(page, all) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "notification.getNotifications",
    params: {
      page: page,
      page_size: 10,
      filters: {
        date_open_from: "2018-06-11",
        date_open_to: "2059-06-11",
        status: all ? 1 : 0
      }
    },
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var headers = {
      "x-rpc-api-version": "4.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    if (informedWebApp.isConnected) {
      dispatch(setNotificationLoading(true));

      return fetch(informedWebApp.api, {
        method: "POST",
        body: body,
        headers: headers,
        cache: "default",
        credentials: "same-origin"
      })
        .then(function(response) {
          var json = response.json();
          return json;
        })
        .then(json => {
          let fff = json;
          dispatch(
            receiveNotifications(
              json.result.data,
              json.result.total === 0 ? -1 : json.result.total
            )
          );
          if (page === 1) {
            let unread = _.filter(json.result.data, function(notification) {
              return notification.dateOpen === null;
            });

            if (unread.length > 0) {
              unread.forEach(element => {
                if (element.dateDelivery === null) {
                  dispatch(receivedNotification(element.id));
                }
              });
              dispatch(alertNotifications(true));
            } else {
              dispatch(alertNotifications(false));
            }
          }
        })
        .then(complete => dispatch(setNotificationLoading(false)));
    }
  };
}

export function setDeviceToken(token) {
  let OS = 1;

  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "account.setDeviceToken",
    params: {
      device_token: token,
      terminal_os: OS
    },
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    if (informedWebApp.isLoggedIn) {
      var headers = {
        "x-rpc-api-version": "5.1.2",
        "x-rpc-auth-device": informedWebApp.deviceId,
        //"x-rpc-auth-session": informedWebApp.sessionId,
        "x-rpc-auth-username": informedWebApp.username,
        "x-rpc-auth-password": informedWebApp.password,
        "content-type": "application/json",
        "cache-control": "no-cache"
      };

      return fetch(informedWebApp.api, {
        method: "POST",
        body: body,
        headers: headers,
        cache: "default",
        credentials: "same-origin"
      })
        .then(function(response) {
          var json = response.json();
          return json;
        })
        .then(json => {
          if (json.error === null) {
            dispatch(setDeviceToken_do(token));
          }
        })
        .catch(error => {
          console.log(error.message);
        });
    } else {
      setTimeout(() => {
        dispatch(setDeviceToken(token));
      }, 3000);
    }
  };
}

export function setDeviceToken_do(value) {
  return {
    type: SET_DEVICE_TOKEN,
    value
  };
}
export function getApprovals(page) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "result.approveItems",
    params: {
      page: page,
      page_size: 20
    },
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"x-rpc-auth-session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    if (informedWebApp.isConnected) {
      dispatch(setLoading(true));

      return fetch(informedWebApp.api, {
        method: "POST",
        body: body,
        headers: headers,
        cache: "default",
        credentials: "same-origin"
      })
        .then(function(response) {
          var json = response.json();
          return json;
        })
        .then(json => {
          let fff = json;
          if (json.result !== null) {
            dispatch(
              receiveSentItemsX(
                json.result.data,
                json.result.total === 0 ? -1 : json.result.total
              )
            );
          } else {
            dispatch(receiveSentItemsX([], 0));
          }
        })
        .then(complete => dispatch(setLoading(false)))
        .catch(error => {});
    }
  };
}

export function getSentItems(page, from_date, to_date, user_id, form_id) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "result.sentItems",
    params: {
      page: page,
      page_size: 20,
      filters: {
        form_id: form_id === "" ? null : form_id,
        user_id: user_id === "" ? null : user_id,
        date_from: from_date,
        date_to: to_date
      }
    },
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var headers = {
      "x-rpc-api-version": "4.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    if (informedWebApp.isConnected) {
      dispatch(setLoading(true));

      return fetch(informedWebApp.api, {
        method: "POST",
        body: body,
        headers: headers,
        cache: "default",
        credentials: "same-origin"
      })
        .then(function(response) {
          var json = response.json();
          return json;
        })
        .then(json => {
          let fff = json;
          dispatch(
            receiveSentItemsX(
              json.result.data,
              json.result.total === 0 ? -1 : json.result.total
            )
          );
        })
        .then(complete => dispatch(setLoading(false)));
    }
  };
}

function receiveSentItemsX(sentItems, total) {
  return dispatch => {
    dispatch(receiveSentItems(sentItems, total));
  };
}

export function updateFormExists(value) {
  return {
    type: UPDATE_FORM_EXISTS,
    value
  };
}

function receiveSentItems(sentItems, total) {
  return {
    type: RECEIVE_SENT_ITEMS,
    sentItems,
    total
  };
}

export function openingSentItem(value) {
  return {
    type: OPENING_SENT_ITEM,
    value
  };
}

function receiveNotifications(notifications, total) {
  return {
    type: RECEIVE_NOTIFICATIONS,
    notifications,
    total
  };
}

export function postStatusHistory(result_id, status, note, context) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "result.postStatusHistory",
    params: {
      result_id: result_id,
      status: status,
      note: note
    },
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"x-rpc-auth-session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    dispatch(setPostingStatus("busy"));

    return fetch(informedWebApp.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(json => {
        dispatch(setPostingStatus("done" + context));
      })
      .catch(error => {
        dispatch(setPostingStatus(""));
        if (error.message === "Network request failed") {
          alert("Lost internet connection, please reconnect and try again.");
        } else {
          alert("postStatusHistory");
        }
      });
  };
}

export function setPostingStatus(value) {
  return {
    type: SET_POSTING_STATUS,
    value
  };
}

export function resetSentItems() {
  return {
    type: RESET_SENT_ITEMS
  };
}

export function readDrafts() {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "draft.getDrafts",
    params: null,
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    dispatch(setLoading(true));

    let drafts = _.filter(informedWebApp.actionQueue, function(data) {
      return (
        data.isDraft === true &&
        data.test ===
          (informedWebApp.api === "https://www.in-formed.co.uk/api.php"
            ? false
            : true)
      );
    });

    return fetch(informedWebApp.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(json => {
        if (json.result.data !== null) {
          drafts.forEach(element => {
            let serverDraft = _.filter(json.result.data, function(data) {
              return data.id === element.result_id;
            });

            if (serverDraft.length > 0) {
            } else {
              dispatch(deleteDraft_do(element.uuid));
            }
          });

          dispatch(receiveDraftsX(json.result));
        } else {
          dispatch(deleteAllDrafts());
        }
      })
      .then(complete => dispatch(setLoading(false)));
  };
}

export function readForms(sessionId, device) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "form.readForms",
    params: null,
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": device,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    dispatch(setLoading(true));
    dispatch(resetForm());
    return fetch(informedWebApp.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(json =>
        dispatch(
          receiveFormsX(sessionId, device, json.result.data, json.result.total)
        )
      )
      .then(() => {
        dispatch(getDatasources());
        dispatch(readDrafts());
      });
  };
}

function authDo(auth) {
  return dispatch => {
    if (!auth) {
      let reset = "";
      dispatch(setAuthSession(reset));
    }

    dispatch(setAuth(auth, ""));
    dispatch(login());
  };
}

function checkAuthentication(json, sessionId, username, password, deviceId) {
  if (json.error !== null) {
    if (json.error.code === -32004 || deviceId == "") {
      return registerDevice(username, password);
    }
  }

  var auth = false;
  if (json.result !== null) {
    auth = true;
  }

  return dispatch => {
    if (!auth) {
      dispatch(setAuthSession(""));
      dispatch(setAuth(auth, json.error.data.fullMessage));
    } else {
      return dispatch(getUserData(auth, sessionId, deviceId));
    }
  };
}

function setLoading(value) {
  return dispatch => {
    dispatch(setLoading_do(value));
  };
}

function setSubmitting_do(value) {
  return dispatch => {
    dispatch(setSubmitting(value));
  };
}

export function updateFormVersion(form_version) {
  return {
    type: UPDATE_FORM_VERSION,
    form_version
  };
}

function setControlLoading_do(element_id, value) {
  return {
    type: SET_CONTROL_LOADING,
    element_id,
    value
  };
}

export function setSubmitting(value) {
  return {
    type: SET_SUBMITTING,
    value
  };
}

export function cancelRepeatingForm() {
  return (dispatch, getState) => {
    const { form } = getState();

    let itemDelete = _.filter(form.draft, function(dsx) {
      return dsx.repeatingFormUUID === form.repeatingFormUUID;
    });

    dispatch(cancelRepeatingFormDo());
  };
}

export function cancelRepeatingFormDo() {
  return {
    type: CANCEL_REPEATING_FORM
  };
}

export function deleteRepeatingFormItem() {
  return (dispatch, getState) => {
    const { form } = getState();
    let item = _.filter(form.data, function(dsx) {
      return dsx.element_type === "19";
    });

    item = _.filter(item, function(dsx) {
      let item2 = _.filter(form.data, function(dsx) {
        return Number(dsx.element_parent) === Number(form.repeatingFormId);
      });
      let result = false;
      item2.forEach(element => {
        if (
          Object.values(dsx.element_params).indexOf(
            element.element_id.toString()
          ) !== -1
        ) {
          result = true;
        }
      });

      return result;
    });

    let itemDelete = _.filter(form.draft, function(dsx) {
      return dsx.repeatingFormUUID === form.repeatingFormUUID;
    });

    item.forEach(element => {
      let totalId = element.element_id;
      let countElement = element.element_params.A;
      let calc = 0;
      let expr = "";
      let itemVal = "";
      let i = 0;

      item = _.filter(form.draft, function(dsx) {
        return Number(dsx.element_id) === Number(countElement);
      });

      item.forEach(element => {
        itemVal = Number(element.element_value);
        if (element.repeatingFormUUID === form.repeatingFormUUID) {
          if (i === 0) {
            expr = calc;
          } else {
            expr += " + " + calc;
          }
        } else {
          if (i === 0) {
            expr = itemVal;
          } else {
            expr += " + " + itemVal;
          }
        }

        i += 1;
      });

      calc = "";
      if (expr !== "") {
        calc = eval(expr);
      }

      if (calc.toString().indexOf(".") !== -1) {
        calc = calc.toFixed(3);
      } else {
        if (calc !== "") {
          calc = calc.toFixed(2);
        }
      }
      if (Number(calc) === 0) {
        calc = "";
      }

      dispatch(updateFormElement(-1, -1, -1, totalId, calc, true));
    });

    dispatch(deleteRepeatingFormItem_do());
  };
}

function deleteRepeatingFormItem_do() {
  return {
    type: DELETE_REPEATING_FORM
  };
}

export function deleteDraft_server(result_id) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "draft.deleteDraft",
    params: {
      id: result_id
    },
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"X-RPC-Auth-Session": sessionId,
      //"X-RPC-Auth-Session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    return fetch(informedWebApp.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(json => {});
  };
}

export function deleteAllDrafts() {
  return {
    type: DELETE_ALL_DRAFTS
  };
}

export function deleteDraft_do(uuid) {
  return {
    type: DELETE_DRAFT,
    uuid
  };
}

export function deleteDraft(uuid, server_id) {
  return dispatch => {
    dispatch(deleteDraft_server(server_id));
    dispatch(deleteDraft_do(uuid));
  };
}

export function setRepeatingForm(value, repeatingFormUUID, index, edit, title) {
  return {
    type: SET_REPEATING_FORM,
    value,
    index,
    repeatingFormUUID,
    edit,
    title
  };
}

function setLoading_do(value) {
  return {
    type: SET_LOADING,
    value
  };
}

export function setFilterUnread(value) {
  return {
    type: SET_FILTER_UNREAD,
    value
  };
}

function setNotificationLoading(value) {
  return {
    type: SET_NOTIFICATION_LOADING,
    value
  };
}

function setDraftSaved(uuid, result_id, date_added, date_modified) {
  return {
    type: SET_DRAFT_SAVED,
    uuid,
    result_id,
    date_added,
    date_modified
  };
}

function receiveFormsX(sessionId, device, forms, total) {
  return dispatch => {
    dispatch(receiveForms(forms, total));
    forms.forEach(element => {
      if (element.approval_enabled) {
        dispatch(
          readFormApprovers(
            sessionId,
            element.form_id,
            device,
            element.form_version
          )
        );
      }
      dispatch(
        readFormControls(
          sessionId,
          element.form_id,
          device,
          element.form_version
        )
      );
    });
  };
}

function receiveDraftsX(drafts, total) {
  return dispatch => {
    drafts.data.forEach(element => {
      dispatch(
        readDraftData(
          element.id,
          element.title,
          element.form_id,
          element.form_version,
          element.date_added
        )
      );
    });
  };
}

function receiveForms(forms, total) {
  return {
    type: RECEIVE_FORMS,
    forms,
    total
  };
}

function updateForms(form) {
  return {
    type: UPDATE_FORMS,
    form
  };
}

function receiveDraftData(
  draftData,
  result_id,
  draft_name,
  form_id,
  form_version,
  icon_path,
  date_added,
  storeId,
  uuid
) {
  return {
    type: RECEIVE_DRAFT_DATA,
    draftData,
    result_id,
    storeId,
    uuid,
    date_added,
    icon_path,
    form_id,
    form_version,
    draft_name
  };
}

function receiveFormControlsX(formControls, formId) {
  return dispatch => {
    dispatch(receiveFormArrayControls(formControls, formId));
  };
}

function receiveFormControls(formControls) {
  return {
    type: RECEIVE_FORM_CONTROLS,
    formControls
  };
}

function receiveFormArrayControls(formControls, formId) {
  return {
    type: RECEIVE_FORM_ARRAY,
    formControls,
    formId
  };
}

function addToQueue(
  draftName,
  result_id,
  formId,
  draft,
  storeId,
  uuid,
  isDraft,
  saved,
  title,
  version,
  icon_path,
  latitude,
  longitude,
  notification_id
) {
  return {
    type: ADD_TO_QUEUE,
    result_id,
    formId,
    draft,
    storeId,
    uuid,
    isDraft,
    saved,
    title,
    version,
    icon_path,
    draftName,
    latitude,
    longitude,
    notification_id
  };
}

export function draftExists(
  result_id,
  title,
  form_id,
  form_version,
  date_added,
  date_modified
) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "draft.getDrafts",
    params: null,
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": informedWebApp.deviceId,
      //"x-rpc-auth-session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    dispatch(setLoading(true));

    return fetch(informedWebApp.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(json => {
        if (json.result.data !== null) {
          let serverDraft = _.filter(json.result.data, function(data) {
            return data.id === result_id;
          });

          if (serverDraft.length === 0) {
            dispatch(updateFormExists(false));
            dispatch(setLoading(false));
            return false;
          } else {
            if (
              new Date(serverDraft[0].date_modified) > new Date(date_modified)
            ) {
              dispatch(
                readDraftData(
                  result_id,
                  title,
                  form_id,
                  form_version,
                  date_added,
                  date_modified
                )
              );
            }
            return true;
          }
        } else {
          dispatch(updateFormExists(false));
          dispatch(setLoading(false));
          return false;
        }
      })
      .catch(error => {
        alert(error.message);
      });
  };
}

function addToImageQueue(
  draftEdit,
  repeatingFormEdit,
  repeatingFormId,
  repeatingFormUUID,
  repeatingFormIndex,
  uuid,
  element_id,
  storeId,
  filename,
  fileType
) {
  return {
    type: ADD_TO_IMAGE_QUEUE,
    draftEdit,
    repeatingFormEdit,
    repeatingFormId,
    repeatingFormUUID,
    repeatingFormIndex,
    uuid,
    storeId,
    element_id,
    filename,
    fileType
  };
}

function removeFromQueue(uuid) {
  return {
    type: REMOVE_FROM_ACTION_QUEUE,
    uuid
  };
}

function removeFromImageQueue(uuid, element_id, repeatingFormUUID) {
  return {
    type: REMOVE_FROM_IMAGE_QUEUE,
    uuid,
    element_id,
    repeatingFormUUID
  };
}

export function savedForm(error) {
  return {
    type: SAVED_FORM,
    error
  };
}

function validateForm(controls) {
  return {
    type: FORM_VALIDATE,
    controls
  };
}
function updateRepeatingFormValidate(value) {
  return {
    type: UPDATE_REPEATING_FORM_VALIDATE,
    value
  };
}
function validateRepeatingForm(controls) {
  return {
    type: REPEATING_FORM_VALIDATE,
    controls
  };
}

export function updateShowMsg(value) {
  return {
    type: UPDATE_SHOW_MSG,
    value
  };
}

export function updateShowMsgRepeat(value) {
  return {
    type: UPDATE_SHOW_MSG_REPEAT,
    value
  };
}

function updateFormValidate(value) {
  return {
    type: UPDATE_FORM_VALIDATE,
    value
  };
}

export function updateFormErrors(value) {
  return {
    type: UPDATE_FORM_ERRORS,
    value
  };
}

export function selectForm(formid) {
  return {
    type: SELECT_FORM,
    formid
  };
}

function repeatingFormValid(state) {
  const errors = state.form.repeatingFormErrors.length;
  if (errors === 0) {
    return true;
  }

  return false;
}

export function readFormApprovers(
  sessionId,
  form_id,
  device,
  version,
  refresh = false,
  cancelId = null
) {
  var body = JSON.stringify({
    jsonrpc: "2.0",
    method: "form.getApprovalGroupsUsers",
    params: {
      form_id: form_id
    },
    id: uuidv4()
  });

  return (dispatch, getState) => {
    const { informedWebApp } = getState();

    var headers = {
      "x-rpc-api-version": "5.1.2",
      "x-rpc-auth-device": device,
      //"x-rpc-auth-session": informedWebApp.sessionId,
      "x-rpc-auth-username": informedWebApp.username,
      "x-rpc-auth-password": informedWebApp.password,
      "content-type": "application/json",
      "cache-control": "no-cache"
    };

    dispatch(setLoading(true));
    return fetch(informedWebApp.api, {
      method: "POST",
      body: body,
      headers: headers,
      cache: "default",
      credentials: "same-origin"
    })
      .then(function(response) {
        var json = response.json();
        return json;
      })
      .then(json => {
        if (refresh) {
          dispatch(receiveFormControls(json.result.data));
          dispatch(receiveApproverArray(json.result.data, form_id));
          let draft = _.filter(json.result.data, function(draft) {
            if (draft.element_params !== null) {
              if (
                draft.element_params.Ds !== undefined &&
                draft.element_type === "16"
              ) {
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
          });
          let v = draft;
          let cv = _(draft)
            .map("element_params.Ds")
            .uniq()
            .value();

          if (cv.length > 0) {
            dispatch(getDatasources(cv, cancelId));
            return true;
          } else {
            return false;
          }
        } else {
          if (json.result !== null) {
            dispatch(receiveApproverArray(json.result.data, form_id));
          }
          return true;
        }
      })
      .then(cancel => {
        if (refresh && !cancel) {
          dispatch(setLoading(false));
        }
      })
      .catch(error => {
        alert("readFormApprovers");
      });
  };
}

function shouldSubmitForm(state) {
  const errors = state.form.errors.length;
  if (errors === 0) {
    return true;
  }

  return false;
}

function receiveApproverArray(approvers, formId) {
  return {
    type: RECEIVE_APPROVER_ARRAY,
    approvers,
    formId
  };
}

export function submitForm(
  copy,
  draftName,
  sessionId,
  form_id,
  draft,
  deviceId,
  uuid,
  isDraft,
  result_id,
  controls,
  lat,
  long,
  drafts,
  approval_enabled,
  notification_id
) {
  return (dispatch, getState) => {
    if (isDraft) {
      return dispatch(
        submitFormDo(
          copy,
          draftName,
          sessionId,
          form_id,
          draft,
          deviceId,
          uuid,
          isDraft,
          result_id,
          lat,
          long,
          drafts,
          approval_enabled,
          notification_id
        )
      );
    } else {
      dispatch(validateForm(controls));
      dispatch(updateShowMsg(true));
      dispatch(updateFormValidate(true));
      if (shouldSubmitForm(getState())) {
        return dispatch(
          submitFormDo(
            copy,
            draftName,
            sessionId,
            form_id,
            draft,
            deviceId,
            uuid,
            isDraft,
            result_id,
            lat,
            long,
            drafts,
            approval_enabled,
            notification_id
          )
        );
      } else {
        dispatch(setSubmitting_do(false));
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js